module.exports = __webpack_public_path__ + "img/DIENTE_SIN_ERUPCIONAR.png";